export class OlUtils {
    constructor() {
    }

    public calculateResolutions(scaleSteps: number[]) {
        var scales = [10000000, 5000000, 1000000, 500000, 250000, 100000, 50000, 25000, 10000, 5000, 1000];
        //1:5000 => 1 enhet på kartan är 5000 enheter i verkligheten. (Enhet = meter) 
        if (scaleSteps != undefined && scaleSteps.length > 0) {
          scales = scaleSteps
        }
        //Pixel/Tum
        var DPI = 96; //DPI Hur många pixlar är en tum  
        //Tum/m 
        var IPM = 39.3701; //1m = 39.37 tum, våran skala är meter så vi vill veta hur många pixlar det går på en meter => DPI * IPM = pixlar/meter
        //Upplösning = skala/visningsenhet => 5000 / 96*39,37 ~ 2050,5208333333333
        //Upplösning = skala/Pixlar/meter
        //Skala = Upplösning/(Pixlar/Meter)
        //Beräkna
        var resolutions = [];
        for (var i = scales.length - 1; i >= 0; --i) {
          resolutions.push(scales[i] / (DPI * IPM));
        }
        //OL3 kräver omvänd ordning.
        return resolutions.reverse();
      }
    
      public calculateScale(resolution: number) {
        //Pixel/Tum
        var DPI = 96; //DPI Hur många pixlar är en tum  
        //Tum/m 
        var IPM = 39.3701; //1m = 39.37 tum, våran skala är meter så vi vill veta hur många pixlar det går på en meter => DPI * IPM = pixlar/meter
        //Beräkna    //OL3 kräver omvänd ordning.
        return resolution * (DPI * IPM);
      }
    
      public calculateResolution(scale: number) {
        //Pixel/Tum
        var DPI = 96; //DPI Hur många pixlar är en tum  
        //Tum/m 
        var IPM = 39.3701; //1m = 39.37 tum, våran skala är meter så vi vill veta hur många pixlar det går på en meter => DPI * IPM = pixlar/meter
        //OL3 kräver omvänd ordning.
        return scale / (DPI * IPM);
      }
}